import { useQuery } from '@tanstack/react-query';

import { GcvAdminApi } from 'api';
import { SFTP_SALES_PROVIDERS_KEY } from 'tanstack-hooks/keys';

export function useSftpSalesProviders() {
  const gcvAdminApi = new GcvAdminApi();

  const { data: sftpSalesProviders, isLoading: isLoadingSftpSalesProviders } = useQuery({
    queryKey: [SFTP_SALES_PROVIDERS_KEY],
    queryFn: () => gcvAdminApi.getSftpSalesProviders(),
    meta: {
      snackbarErrorMessage: 'There was an issue loading SFTP sales providers. Please try again.'
    }
  });

  return { sftpSalesProviders: sftpSalesProviders ?? [], isLoadingSftpSalesProviders };
}
